import { createSlice } from "@reduxjs/toolkit";
import { AppDispatch } from "configureStore";

interface FuelReportsState {
  refreshNonce: number;
}

const initialState: FuelReportsState = {
  refreshNonce: 0,
};

const FuelReportsSlice = createSlice({
  name: "fuelReports",
  initialState,
  reducers: {
    setDestroy() {
      return initialState;
    },
    requestFuelReportsRefresh(state: FuelReportsState) {
      state.refreshNonce += 1;
    },
  },
});

const { actions, reducer } = FuelReportsSlice;

export const { setDestroy, requestFuelReportsRefresh } = actions;
export default reducer;

/** Backward-compatible alias used after create/edit fuel report. */
export const fetchFuelReportsThunk =
  (_companyId?: string, _filtersValue?: unknown) =>
  (dispatch: AppDispatch) => {
    dispatch(requestFuelReportsRefresh());
  };
